<template>
  <div v-if="permission">
    <distribution-rate></distribution-rate>
    <price-strategy></price-strategy>
    <sales-profit></sales-profit>
  </div>
</template>

<script>
import distributionRate from './distribution-rate'
import priceStrategy from './price-strategy'
import  salesProfit from './sales-profit'
import {mapGetters, mapActions} from "vuex";
export default {
  name: "report",

  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.permission = true
        }
      }
    }
  },
  components: {
    distributionRate,priceStrategy,salesProfit
  },
  data() {
    return {
     permission:false
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spd/logistics/report.vue